export const QUESTIONNAIRE_EMAIL_SEND_MODE = {
  NONE: 'NONE',
  ANSWEREE_SELECT: 'ANSWEREE_SELECT',
  EMAIL_RESEND: 'EMAIL_RESEND',
  QUESTIONNAIRE_ACCEPT: 'QUESTIONNAIRE_ACCEPT',
  QUESTIONNAIRE_REJECT: 'QUESTIONNAIRE_REJECT',
};